/* import __COLOCATED_TEMPLATE__ from './subaccount-name-input.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { later } from '@ember/runloop';
import { inject as service } from '@ember/service';
import { focusOnTemporaryInput } from '@banking/ui/utils/dom';
import environment from '@square/environment-utils/environment';
let SubaccountNameInput = (_class = class SubaccountNameInput extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "showEditIcon", _descriptor2, this);
    _defineProperty(this, "inputElement", null);
  }
  focus(el) {
    let tempInput = null;
    this.inputElement = el;
    const {
      isIOS
    } = environment();
    /**
     * https://stackoverflow.com/a/55652503
     * On IOS, if there is a delay before setting focus(e.g. waiting for marketDialoagLoaded event)
     * autofocus attribute doesn't work, unless another input already has focus
     */
    if (isIOS && document.activeElement !== this.inputElement) {
      tempInput = focusOnTemporaryInput();
    }

    // The market modal takes a second to appear and so the ember ways of
    // autofocusing don't work because they fire too fast.
    // The normal HTML attribute works the first time but not on subsequent
    // renders for some reason.
    const modal = el.closest('market-modal-partial');
    modal?.addEventListener('marketDialogLoaded', () => {
      this.resizeInput(el);
      later(() => {
        el.focus();
        tempInput?.remove();
      }, 1);
    }, {
      // For some reason this event seems to fire twice
      // https://github.com/squareup/market/issues/3822
      once: true
    });
    // Market dialog may already be loaded, so ensure we are always calling this.resizeInput
    // UI needs extra time to render the input content and set the input width
    later(() => {
      this.resizeInput(el);
    }, 1);
  }
  onInput(event) {
    if (event.target) {
      this.resizeInput(event.target);
    }
  }
  focusInput() {
    if (this.inputElement) {
      this.inputElement.focus();
    }
  }
  resizeInput(el) {
    el.style.width = 'auto';
    // Ensure input width is not too small so that user can always click on it
    if (el.scrollWidth > 32) {
      // By default the input width is large which is causing the edit icon to be rendered far from the input text
      // when text is short. "size" changes the minimum width of input
      // We are setting this in JS instead of HBS to prevent flickering effect happens occasionally
      el.size = 3;
      el.style.width = `${el.scrollWidth}px`;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showEditIcon", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "focus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusInput"), _class.prototype), _class);
export { SubaccountNameInput as default };